/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DraftNotificationStatistics} from '../models/DraftNotificationStatistics';
import type {Error} from '../models/Error';
import type {SsoDraft} from '../models/SsoDraft';
import type {SsoDraftCompletionDurationStatistic} from '../models/SsoDraftCompletionDurationStatistic';
import type {SsoDraftInProgressAgeStatistic} from '../models/SsoDraftInProgressAgeStatistic';
import type {SsoDraftMandatoryDistribution} from '../models/SsoDraftMandatoryDistribution';
import type {SsoDraftOverallStatistics} from '../models/SsoDraftOverallStatistics';
import type {SsoDraftProviderCompletionStatistics} from '../models/SsoDraftProviderCompletionStatistics';
import type {SsoDraftProviderDistribution} from '../models/SsoDraftProviderDistribution';
import type {SsoDraftProviderOutcomeStatistics} from '../models/SsoDraftProviderOutcomeStatistics';
import type {SsoDraftSearchCriteria} from '../models/SsoDraftSearchCriteria';
import type {SsoDraftSearchResponse} from '../models/SsoDraftSearchResponse';
import type {SsoDraftStatisticsResponse} from '../models/SsoDraftStatisticsResponse';
import type {SsoDraftStatusDistribution} from '../models/SsoDraftStatusDistribution';
import type {SsoDraftStepFunnelStatistic} from '../models/SsoDraftStepFunnelStatistic';

export interface DeleteSsoDraft$Request {
    draftId: number;
}

export interface DeleteSsoDraft$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteSsoDraftRequest = createAction<PayloadData<void, DeleteSsoDraft$Request>>('SSO_DRAFTS__DELETE_SSO_DRAFT__REQUEST');
export const deleteSsoDraftSuccess = createAction<PayloadData<void, DeleteSsoDraft$Request>>('SSO_DRAFTS__DELETE_SSO_DRAFT__SUCCESS');
export const deleteSsoDraftFailure = createAction<PayloadData<Error, DeleteSsoDraft$Request, true>>('SSO_DRAFTS__DELETE_SSO_DRAFT__FAILURE');

export const deleteSsoDraftActions = [
    deleteSsoDraftRequest,
    deleteSsoDraftSuccess,
    deleteSsoDraftFailure
] as const;

/**
 * @param {number} meta.draftId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteSsoDraft = (meta: DeleteSsoDraft$Request, config?: DeleteSsoDraft$Config) => {
    return {
        CALL_API: {
            types: deleteSsoDraftActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/sso-drafts/${meta.draftId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetNotificationStatisticById$Request {
    draftId: number;
}

export interface GetNotificationStatisticById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getNotificationStatisticByIdRequest = createAction<PayloadData<void, GetNotificationStatisticById$Request>>('SSO_DRAFTS__GET_NOTIFICATION_STATISTIC_BY_ID__REQUEST');
export const getNotificationStatisticByIdSuccess = createAction<PayloadData<DraftNotificationStatistics, GetNotificationStatisticById$Request>>('SSO_DRAFTS__GET_NOTIFICATION_STATISTIC_BY_ID__SUCCESS');
export const getNotificationStatisticByIdFailure = createAction<PayloadData<Error, GetNotificationStatisticById$Request, true>>('SSO_DRAFTS__GET_NOTIFICATION_STATISTIC_BY_ID__FAILURE');

export const getNotificationStatisticByIdActions = [
    getNotificationStatisticByIdRequest,
    getNotificationStatisticByIdSuccess,
    getNotificationStatisticByIdFailure
] as const;

/**
 * @param {number} meta.draftId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getNotificationStatisticById = (meta: GetNotificationStatisticById$Request, config?: GetNotificationStatisticById$Config) => {
    return {
        CALL_API: {
            types: getNotificationStatisticByIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/${meta.draftId}/notifications/statistics`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSsoDraftByAccountId$Request {
    accountId: number;
}

export interface GetSsoDraftByAccountId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftByAccountIdRequest = createAction<PayloadData<void, GetSsoDraftByAccountId$Request>>('SSO_DRAFTS__GET_SSO_DRAFT_BY_ACCOUNT_ID__REQUEST');
export const getSsoDraftByAccountIdSuccess = createAction<PayloadData<SsoDraft, GetSsoDraftByAccountId$Request>>('SSO_DRAFTS__GET_SSO_DRAFT_BY_ACCOUNT_ID__SUCCESS');
export const getSsoDraftByAccountIdFailure = createAction<PayloadData<Error, GetSsoDraftByAccountId$Request, true>>('SSO_DRAFTS__GET_SSO_DRAFT_BY_ACCOUNT_ID__FAILURE');

export const getSsoDraftByAccountIdActions = [
    getSsoDraftByAccountIdRequest,
    getSsoDraftByAccountIdSuccess,
    getSsoDraftByAccountIdFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftByAccountId = (meta: GetSsoDraftByAccountId$Request, config?: GetSsoDraftByAccountId$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftByAccountIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/accounts/${meta.accountId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSsoDraftCompletionDurationStatistics$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftCompletionDurationStatisticsRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_COMPLETION_DURATION_STATISTICS__REQUEST');
export const getSsoDraftCompletionDurationStatisticsSuccess = createAction<PayloadData<Array<SsoDraftCompletionDurationStatistic>>>('SSO_DRAFTS__GET_SSO_DRAFT_COMPLETION_DURATION_STATISTICS__SUCCESS');
export const getSsoDraftCompletionDurationStatisticsFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_COMPLETION_DURATION_STATISTICS__FAILURE');

export const getSsoDraftCompletionDurationStatisticsActions = [
    getSsoDraftCompletionDurationStatisticsRequest,
    getSsoDraftCompletionDurationStatisticsSuccess,
    getSsoDraftCompletionDurationStatisticsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftCompletionDurationStatistics = (config?: GetSsoDraftCompletionDurationStatistics$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftCompletionDurationStatisticsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics/completion-duration-buckets`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSsoDraftInProgressAgeStatistics$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftInProgressAgeStatisticsRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_IN_PROGRESS_AGE_STATISTICS__REQUEST');
export const getSsoDraftInProgressAgeStatisticsSuccess = createAction<PayloadData<Array<SsoDraftInProgressAgeStatistic>>>('SSO_DRAFTS__GET_SSO_DRAFT_IN_PROGRESS_AGE_STATISTICS__SUCCESS');
export const getSsoDraftInProgressAgeStatisticsFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_IN_PROGRESS_AGE_STATISTICS__FAILURE');

export const getSsoDraftInProgressAgeStatisticsActions = [
    getSsoDraftInProgressAgeStatisticsRequest,
    getSsoDraftInProgressAgeStatisticsSuccess,
    getSsoDraftInProgressAgeStatisticsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftInProgressAgeStatistics = (config?: GetSsoDraftInProgressAgeStatistics$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftInProgressAgeStatisticsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics/in-progress-age-buckets`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSsoDraftMandatoryDistribution$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftMandatoryDistributionRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_MANDATORY_DISTRIBUTION__REQUEST');
export const getSsoDraftMandatoryDistributionSuccess = createAction<PayloadData<Array<SsoDraftMandatoryDistribution>>>('SSO_DRAFTS__GET_SSO_DRAFT_MANDATORY_DISTRIBUTION__SUCCESS');
export const getSsoDraftMandatoryDistributionFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_MANDATORY_DISTRIBUTION__FAILURE');

export const getSsoDraftMandatoryDistributionActions = [
    getSsoDraftMandatoryDistributionRequest,
    getSsoDraftMandatoryDistributionSuccess,
    getSsoDraftMandatoryDistributionFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftMandatoryDistribution = (config?: GetSsoDraftMandatoryDistribution$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftMandatoryDistributionActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics/mandatory-distribution`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSsoDraftOverallStatistics$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftOverallStatisticsRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_OVERALL_STATISTICS__REQUEST');
export const getSsoDraftOverallStatisticsSuccess = createAction<PayloadData<SsoDraftOverallStatistics>>('SSO_DRAFTS__GET_SSO_DRAFT_OVERALL_STATISTICS__SUCCESS');
export const getSsoDraftOverallStatisticsFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_OVERALL_STATISTICS__FAILURE');

export const getSsoDraftOverallStatisticsActions = [
    getSsoDraftOverallStatisticsRequest,
    getSsoDraftOverallStatisticsSuccess,
    getSsoDraftOverallStatisticsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftOverallStatistics = (config?: GetSsoDraftOverallStatistics$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftOverallStatisticsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics/overall`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSsoDraftProviderCompletionStatistics$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftProviderCompletionStatisticsRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_PROVIDER_COMPLETION_STATISTICS__REQUEST');
export const getSsoDraftProviderCompletionStatisticsSuccess = createAction<PayloadData<Array<SsoDraftProviderCompletionStatistics>>>('SSO_DRAFTS__GET_SSO_DRAFT_PROVIDER_COMPLETION_STATISTICS__SUCCESS');
export const getSsoDraftProviderCompletionStatisticsFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_PROVIDER_COMPLETION_STATISTICS__FAILURE');

export const getSsoDraftProviderCompletionStatisticsActions = [
    getSsoDraftProviderCompletionStatisticsRequest,
    getSsoDraftProviderCompletionStatisticsSuccess,
    getSsoDraftProviderCompletionStatisticsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftProviderCompletionStatistics = (config?: GetSsoDraftProviderCompletionStatistics$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftProviderCompletionStatisticsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics/provider-completion-times`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSsoDraftProviderDistribution$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftProviderDistributionRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_PROVIDER_DISTRIBUTION__REQUEST');
export const getSsoDraftProviderDistributionSuccess = createAction<PayloadData<Array<SsoDraftProviderDistribution>>>('SSO_DRAFTS__GET_SSO_DRAFT_PROVIDER_DISTRIBUTION__SUCCESS');
export const getSsoDraftProviderDistributionFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_PROVIDER_DISTRIBUTION__FAILURE');

export const getSsoDraftProviderDistributionActions = [
    getSsoDraftProviderDistributionRequest,
    getSsoDraftProviderDistributionSuccess,
    getSsoDraftProviderDistributionFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftProviderDistribution = (config?: GetSsoDraftProviderDistribution$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftProviderDistributionActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics/provider-distribution`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSsoDraftProviderOutcomeStatistics$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftProviderOutcomeStatisticsRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_PROVIDER_OUTCOME_STATISTICS__REQUEST');
export const getSsoDraftProviderOutcomeStatisticsSuccess = createAction<PayloadData<Array<SsoDraftProviderOutcomeStatistics>>>('SSO_DRAFTS__GET_SSO_DRAFT_PROVIDER_OUTCOME_STATISTICS__SUCCESS');
export const getSsoDraftProviderOutcomeStatisticsFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_PROVIDER_OUTCOME_STATISTICS__FAILURE');

export const getSsoDraftProviderOutcomeStatisticsActions = [
    getSsoDraftProviderOutcomeStatisticsRequest,
    getSsoDraftProviderOutcomeStatisticsSuccess,
    getSsoDraftProviderOutcomeStatisticsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftProviderOutcomeStatistics = (config?: GetSsoDraftProviderOutcomeStatistics$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftProviderOutcomeStatisticsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics/provider-outcomes`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSsoDraftStatistics$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftStatisticsRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_STATISTICS__REQUEST');
export const getSsoDraftStatisticsSuccess = createAction<PayloadData<SsoDraftStatisticsResponse>>('SSO_DRAFTS__GET_SSO_DRAFT_STATISTICS__SUCCESS');
export const getSsoDraftStatisticsFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_STATISTICS__FAILURE');

export const getSsoDraftStatisticsActions = [
    getSsoDraftStatisticsRequest,
    getSsoDraftStatisticsSuccess,
    getSsoDraftStatisticsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftStatistics = (config?: GetSsoDraftStatistics$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftStatisticsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSsoDraftStatusDistribution$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftStatusDistributionRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_STATUS_DISTRIBUTION__REQUEST');
export const getSsoDraftStatusDistributionSuccess = createAction<PayloadData<Array<SsoDraftStatusDistribution>>>('SSO_DRAFTS__GET_SSO_DRAFT_STATUS_DISTRIBUTION__SUCCESS');
export const getSsoDraftStatusDistributionFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_STATUS_DISTRIBUTION__FAILURE');

export const getSsoDraftStatusDistributionActions = [
    getSsoDraftStatusDistributionRequest,
    getSsoDraftStatusDistributionSuccess,
    getSsoDraftStatusDistributionFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftStatusDistribution = (config?: GetSsoDraftStatusDistribution$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftStatusDistributionActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics/status-distribution`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSsoDraftStepFunnelStatistics$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoDraftStepFunnelStatisticsRequest = createAction<PayloadData<void>>('SSO_DRAFTS__GET_SSO_DRAFT_STEP_FUNNEL_STATISTICS__REQUEST');
export const getSsoDraftStepFunnelStatisticsSuccess = createAction<PayloadData<Array<SsoDraftStepFunnelStatistic>>>('SSO_DRAFTS__GET_SSO_DRAFT_STEP_FUNNEL_STATISTICS__SUCCESS');
export const getSsoDraftStepFunnelStatisticsFailure = createAction<PayloadData<Error, void, true>>('SSO_DRAFTS__GET_SSO_DRAFT_STEP_FUNNEL_STATISTICS__FAILURE');

export const getSsoDraftStepFunnelStatisticsActions = [
    getSsoDraftStepFunnelStatisticsRequest,
    getSsoDraftStepFunnelStatisticsSuccess,
    getSsoDraftStepFunnelStatisticsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoDraftStepFunnelStatistics = (config?: GetSsoDraftStepFunnelStatistics$Config) => {
    return {
        CALL_API: {
            types: getSsoDraftStepFunnelStatisticsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso-drafts/statistics/step-funnel`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface PostponeSsoDraftById$Request {
    draftId: number;
}

export interface PostponeSsoDraftById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const postponeSsoDraftByIdRequest = createAction<PayloadData<void, PostponeSsoDraftById$Request>>('SSO_DRAFTS__POSTPONE_SSO_DRAFT_BY_ID__REQUEST');
export const postponeSsoDraftByIdSuccess = createAction<PayloadData<void, PostponeSsoDraftById$Request>>('SSO_DRAFTS__POSTPONE_SSO_DRAFT_BY_ID__SUCCESS');
export const postponeSsoDraftByIdFailure = createAction<PayloadData<Error, PostponeSsoDraftById$Request, true>>('SSO_DRAFTS__POSTPONE_SSO_DRAFT_BY_ID__FAILURE');

export const postponeSsoDraftByIdActions = [
    postponeSsoDraftByIdRequest,
    postponeSsoDraftByIdSuccess,
    postponeSsoDraftByIdFailure
] as const;

/**
 * @param {number} meta.draftId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const postponeSsoDraftById = (meta: PostponeSsoDraftById$Request, config?: PostponeSsoDraftById$Config) => {
    return {
        CALL_API: {
            types: postponeSsoDraftByIdActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/sso-drafts/${meta.draftId}/postpone`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SearchSsoDrafts$Request {
    ssoDraftSearchCriteria: SsoDraftSearchCriteria;
}

export interface SearchSsoDrafts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchSsoDraftsRequest = createAction<PayloadData<void, SearchSsoDrafts$Request>>('SSO_DRAFTS__SEARCH_SSO_DRAFTS__REQUEST');
export const searchSsoDraftsSuccess = createAction<PayloadData<SsoDraftSearchResponse, SearchSsoDrafts$Request>>('SSO_DRAFTS__SEARCH_SSO_DRAFTS__SUCCESS');
export const searchSsoDraftsFailure = createAction<PayloadData<Error, SearchSsoDrafts$Request, true>>('SSO_DRAFTS__SEARCH_SSO_DRAFTS__FAILURE');

export const searchSsoDraftsActions = [
    searchSsoDraftsRequest,
    searchSsoDraftsSuccess,
    searchSsoDraftsFailure
] as const;

/**
 * @param {SsoDraftSearchCriteria} meta.ssoDraftSearchCriteria
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchSsoDrafts = (meta: SearchSsoDrafts$Request, config?: SearchSsoDrafts$Config) => {
    return {
        CALL_API: {
            types: searchSsoDraftsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/sso-drafts/search`,
            TRANSPORT_REQUEST_BODY: meta.ssoDraftSearchCriteria,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

